/*
  Cart deck preview loader: the only deck-preview script every page pays for.
  The cart page and the cart drawer render it; it loads trc-deck-art.js and
  trc-cart-deck-preview.js (URLs on its own tag) the first time the cart has a
  deck line, at load or after the theme re-renders the cart (cart:updated,
  which cart.js fires after every section re-render).
*/
(function () {
  'use strict';
  if (window.TRCCartDeckBoot) return;
  var started = false;
  function load() {
    var tag = document.querySelector('script[data-trc-cart-deck-boot]');
    if (!tag) return;
    started = true;
    ['data-art', 'data-preview'].forEach(function (name) {
      var src = tag.getAttribute(name);
      if (!src || !/\.js(?:\?|$)/.test(src)) return;
      var script = document.createElement('script');
      script.src = src;
      script.async = false; // keeps the order: the art module first
      document.head.appendChild(script);
    });
  }
  function scan() {
    if (!started && document.querySelector('trc-cart-deck')) load();
  }
  window.TRCCartDeckBoot = { scan: scan, started: function () { return started; } };
  document.addEventListener('cart:updated', scan);
  document.addEventListener('product-ajax:added', scan);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
